import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CompareViewModel from "../viewModel";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const Description = () => {
  const { t, i18n } = useTranslation();
  const { compareItems } = useContext(CompareViewModel.Context);

  return (
    <tr>
      <th className="title-column">{t("compare.description")}</th>
      {compareItems.map(({ description, _id }) => (
        <td className="product-desc" key={_id}>
          {description ? (
            <p>{getMultiLangProperty(description, i18n.language)}</p>
          ) : (
            "---"
          )}
        </td>
      ))}
    </tr>
  );
};

export default Description;
